// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loder_loader__2LUME","spin":"Loder_spin__3iTkm"};